import dayjs from 'dayjs';

const MD_PATTERN = /^\d{2}-\d{2}$/;

// `customParseFormat` is extended app-wide in `apps/admin/src/main.tsx`.
export default function getNextDateFromMonthDay(
  md?: string | null,
): string | undefined {
  if (!md || !MD_PATTERN.test(md)) return undefined;

  const today = dayjs().startOf('day');
  let year = today.year();

  // Cap at 8 iterations — handles `02-29` worst-case (next leap year ≤ 4 away).
  for (let i = 0; i < 8; i += 1) {
    const candidate = dayjs(`${year}-${md}`, 'YYYY-MM-DD', true);
    if (candidate.isValid() && !candidate.isBefore(today)) {
      return candidate.format('YYYY-MM-DD');
    }
    year += 1;
  }

  return undefined;
}
